export default __webpack_public_path__ + "static/media/info-circle.9ddf6077.svg";